export class RealTimeCheck {
  constructor(
    public hash: string = null,
    public firstname: string = null,
    public lastname: string = null,
    public startAddress: string = null,
    public startLatitude: number = null,
    public startLongitude: number = null,
    public startTime: number = null
  ) { }

  get fullname() {
    return `${this.firstname} ${this.lastname}`;
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/models/real-time-check.ts